import { ApolloLink, FetchResult, Observable, Operation } from '@apollo/client';
import { GraphQLError } from 'graphql';

import { SandboxStore, sandboxStore } from '../store';
import { resolveSandboxOperation } from './operationRegistry';

export class SandboxApolloLink extends ApolloLink {
  constructor(private readonly store: SandboxStore = sandboxStore) {
    super();
  }

  request(operation: Operation): Observable<FetchResult> {
    return new Observable((observer) => {
      Promise.resolve()
        .then(() =>
          resolveSandboxOperation(
            operation.operationName,
            operation.variables,
            this.store
          )
        )
        .then((data) => observer.next({ data }))
        .catch((error: Error) =>
          observer.next({
            errors: [
              new GraphQLError(
                error.message,
                undefined,
                undefined,
                undefined,
                undefined,
                error
              ),
            ],
          })
        )
        .finally(() => observer.complete());
    });
  }
}
